import { TableType } from 'src/shared/enums';

interface ITableFields {
    [key: number]: any;
}

const importTableFields: ITableFields[] = [];

importTableFields[TableType.CALIBRATION_USES] = ['Use name'];


export default importTableFields;
